"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (client) {
    var getParams = getGetParams();
    if (!getParams.has('api_key') || !getParams.has('compenda_user_id')) {
        return false;
    }
    var apiKey = String(getParams.get('api_key'));
    var compendaUserId = Number(getParams.get('compenda_user_id'));
    setAuthHeaders(client, apiKey, compendaUserId);
    return true;
});
var getGetParams = function () {
    var getParams = new Map();
    location.search
        .substr(1)
        .split('&')
        .forEach(function (item) {
        var _a = item.split('='), key = _a[0], value = _a[1];
        getParams.set(key, value);
    });
    return getParams;
};
var setAuthHeaders = function (client, apiKey, compendaUserId) {
    client.defaults.headers.common.Authorization = 'Bearer ' + apiKey;
    client.defaults.headers.common.CompendaUserId = compendaUserId;
};
